import React, { useState } from 'react';
import './style.css'; // Assuming you have a CSS file for styles

function SliderComponent({ onChange, value: initialValue = 10  }) {
    const [value, setValue] = useState(initialValue); // Initial slider position

    const handleChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        if (onChange) {
            onChange(newValue); // Call the passed onChange function with the new value
        }
    };

    return (
        <div className="slider-container">
            <input 
                type="range" 
                min="0" 
                max="100" 
                value={value} 
                className="slider" 
                onChange={handleChange} 
            />
            <div className="labels">
                <span>1/4</span>
                <span>1/2</span>
                <span>3/4</span>
                <span>1/1</span>
            </div>
        </div>
    );
}

export default SliderComponent;
